import { ApprovalPrompt, type PendingApproval } from '@pos/design-system';
import { useTranslation } from '@pos/i18n';
import { asProblem, problemMessage } from '../problems';
import { useOrdersApi } from './model';

/** The manager's staff code and password for one pending approval (see useApprovalFlow). */
export function ApprovalDialog({ pending }: { pending: PendingApproval | undefined }) {
  const { t } = useTranslation();
  const api = useOrdersApi();
  return (
    <ApprovalPrompt
      pending={pending}
      approve={async (target, staffCode, password) => (await api.approve({ ...target, staffCode, password })).approvalId}
      describeError={(error) => problemMessage(t, asProblem(error))}
    />
  );
}
